import React from "react";
import styles from "./style.module.scss";
import Layout from "../../../components/Layout/authenticatedLayout";

import UsersByPageList from "../../../components/Admin/UsersByPageList";
import AdminDataManager from "../../../components/DataManagers/AdminDataManager";
import LogConsole from "../../../components/Admin/LogConsole";
import V2Controls from "../../../components/Admin/V2Controls";
import WinTAXResetControls from "../../../components/Admin/WinTAXResetControls";
import DashboardResetControls from "../../../components/Admin/AKSDashboardResetControls";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";
import ConnectedServices from "../../../components/Admin/ConnectedServices";
import ServerTime from "../../../components/Admin/ServerTime";
import TrackMapSelector from "../../../components/Admin/TrackMapSelector";
import TrackMapDataManager from "../../../components/DataManagers/TrackMapDataManager";

function ServerPage() {
  return (
    <Layout title={"Server"}>
      <AdminDataManager />
      <TimingDataManager />
      <TrackMapDataManager />
      <div className={styles.container}>
        <UsersByPageList />
        <LogConsole />
        <div className={styles.column}>
          <V2Controls />
          <TrackMapSelector />
        </div>
        <div className={styles.column}>
          <ConnectedServices />
          <ServerTime />
          <DashboardResetControls />
          <WinTAXResetControls />
        </div>
      </div>
    </Layout>
  );
}

export default ServerPage;
